import { render, staticRenderFns } from "./CheckAbility.vue?vue&type=template&id=4ef54152&scoped=true&"
import script from "./CheckAbility.vue?vue&type=script&lang=js&"
export * from "./CheckAbility.vue?vue&type=script&lang=js&"
import style0 from "./CheckAbility.vue?vue&type=style&index=0&id=4ef54152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef54152",
  null
  
)

export default component.exports